export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/tangerine-flavor.074c3354820283b11da157ce9290935a.png";